/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';
import { ToastMessageType } from 'primereact/toast';
import { toastRef } from '../components/Layout/Layout';
import ErrorUtilities from '../shared/Utilities/errorUtilities';

const axiosInstance = axios.create({});

axiosInstance.interceptors.request.use(request => {
    request.baseURL = window.location.origin + '/api/';
    return request;
});


axiosInstance.interceptors.response.use(response => {
    return response
},
    error => {
        const encodedCurrentUrl = encodeURIComponent(window.location.href);
        error = extractError(error, encodedCurrentUrl);

        return Promise.reject(error);
    }
);



const extractError = (error: any, encodedCurrentUrl: string) => {
    if (axios.isCancel(error)) {
        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
        console.log(error.message);
    }
    else if (error.response && error.response.status === 403 && !ErrorUtilities.InstanceOfMyArgumentException(error.response.data)) {
        var loginPageUrl = `${window.location.origin}/api/Users/login?redirectUrl=${encodedCurrentUrl}`;
        window.location.href = loginPageUrl;
    }
    else {

        ///Restituisce Null se l'errore non è di tipo MyArgumentException
        let toastMessage: ToastMessageType | null = ErrorUtilities.GetToastPropFromMyArgumentException(error);
        if (toastMessage) {
            toastRef.current?.show(toastMessage);
            /// setto isErrorShown per impedire che venga mostrato un secondo alert 
            error = { ...error, isErrorShown: true };
        }
    }
    return error;
}

export default  axiosInstance;
